import { Injectable } from '@angular/core';
import {
  ACCEPT_VERSION_HEADER,
  AuthHttpService,
} from '../auth-data/auth-http.service';
import { ITopLevelKeys } from '../entity-data/entity-data.data';
import { EntityDataService } from '../entity-data/entity-data.service';
import { ErrorService } from '../error-reporting/error.service';
import { SettingsDataStore } from '../settings-data/settings-data.store';
import { LoggerService } from '../shared/services/logger/logger.service';
import { AppointmentDataBuilder } from './appointment-data.builder';
import { Observable } from 'rxjs';
import { IResponseInfo } from '../http/http.data';
import { AppointmentFilters } from './models/appointment-filters.model';
import { GlobalSearch } from '../search-data/global-search.model';
import { map } from 'rxjs/operators';

export const APPOINTMENT_URL = '/appointments';
export const APPOINTMENT_FILTER_ACCEPT_VERSION = '1.0.0';
export const APPOINTMENT_SEARCH_ACCEPT_VERSION = '1.0.0';
export const APPOINTMENT_ACCEPT_VERSION = '1.2.0';

@Injectable()
export class AppointmentDataService extends EntityDataService {
  protected inputHeaders: any = {
    [ACCEPT_VERSION_HEADER]: APPOINTMENT_ACCEPT_VERSION,
  };
  protected filtersHeaders: any = {
    [ACCEPT_VERSION_HEADER]: APPOINTMENT_FILTER_ACCEPT_VERSION,
  };
  protected searchHeaders: any = {
    [ACCEPT_VERSION_HEADER]: APPOINTMENT_SEARCH_ACCEPT_VERSION,
  };

  topLevelKeys: ITopLevelKeys = {
    getKey: 'appointments',
    postKey: 'created_appointment',
    putKey: 'updated_appointment',
    deletedKey: 'deleted_appointments',
    deleteSingleKey: 'deleted_appointment',
    getSingleKey: 'appointment',
    searchResultsKey: 'appointment_results',
    globalSearchResultsKey: GlobalSearch.KEYS.APPOINTMENTS,
  };

  constructor(
    authHttpService: AuthHttpService,
    loggerService: LoggerService,
    errorService: ErrorService,
    appointmentDataBuilder: AppointmentDataBuilder,
    settingsDataStore: SettingsDataStore
  ) {
    super(
      authHttpService,
      APPOINTMENT_URL,
      loggerService,
      errorService,
      appointmentDataBuilder,
      settingsDataStore
    );
  }

  getFilters(listFilter?: string): Observable<AppointmentFilters> {
    const url = `${this.entitiesUrl}/filters`;

    return this.authHttpService
      .get(url, {}, this.filtersHeaders)
      .pipe(
        map(({ body, ..._ }: IResponseInfo) => new AppointmentFilters(body))
      );
  }
}
